


















































import { computed, defineComponent } from "@vue/composition-api";
import { connectionStateEnum } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import LeavingPrivate from "../LeavingPrivate";

export default defineComponent({
  name: "StreamViewOverlay",
  components: { BaseIcon, LeavingPrivate, BaseButton },
  props: {
    loading: { type: Boolean, required: true },
    connecting: { type: Boolean, required: true },
    connectingState: { type: String, required: true },
    isStreamAlive: { type: Boolean, required: true },
    showLeavingPrivate: { type: Boolean, required: true },
    showGoingPrivate: { type: Boolean, required: true },
    isPrivateLive: { type: Boolean, required: true },
    ownerIsBusy: { type: Boolean, required: true },
    isOwner: { type: Boolean, required: true },
    isAdmin: { type: Boolean, required: true },
  },
  setup(props) {
    const overlayClass = computed(() => ({
      __background: props.loading || props.connecting || props.showGoingPrivate || props.showLeavingPrivate,
    }));
    const showOwnerInPrivate = computed(() => !props.isPrivateLive && props.ownerIsBusy);

    return {
      overlayClass,
      showOwnerInPrivate,
      connectionStateEnum,
    };
  },
});
